export const DEFAULT_PRIORITY = 50
export const DEFAULT_ID = 'initial'
export const DEFAULT_STATUS = 'New'
export const DEFAULT_TYPE = 'service'
